<template>
  <v-bottom-navigation app height="120">
    <v-row dense>
      <v-col cols="6" class="pr-0">
        <v-btn
          block
          height="120"
          color="#164b0a"
          dark
          :href="link_regulamento"
          target="_blank"
        >
          <template v-if="isMobile()">
            <span class="title white--text mt-2">Regulamento</span>
            <v-icon large color="white">mdi-file-document-check-outline</v-icon>
          </template>
          <template v-else>
            <v-list-item class="text-center">
              <v-list-item-content>
                <v-list-item-title class="headline"
                  >Regulamento</v-list-item-title
                >
                <v-list-item-subtitle class="subtitle-1"
                  >Confira as regras da promoção</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-btn>
      </v-col>
      <v-col cols="6" class="pl-0">
        <v-btn block height="120" color="#090845" dark @click="setConsultarCupom(true)">
          <template v-if="isMobile()">
            <span class="title white--text mt-2">Consultar cupons</span>
            <v-icon color="white" large>mdi-magnify</v-icon>
          </template>
          <template v-else>
            <v-list-item class="text-center">
              <v-list-item-content>
                <v-list-item-title class="headline"
                  >Consultar Cupons</v-list-item-title
                >
                <v-list-item-subtitle class="subtitle-1"
                  >Consulte seus bilhetes da sorte</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-btn>
      </v-col>
    </v-row>
  </v-bottom-navigation>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState(["link_regulamento"]),    
  },
  methods: {
    ...mapMutations(["setConsultarCupom"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>